var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-1.5v1.5H21V21H3v-4.5h1.5V15H3a1.502 1.502 0 00-1.5 1.5V21A1.502 1.502 0 003 22.5h18a1.502 1.502 0 001.5-1.5v-4.5A1.502 1.502 0 0021 15z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 19.5a.75.75 0 100-1.5.75.75 0 000 1.5zM17.03 5.47l-3.75-3.75a.75.75 0 00-.53-.22h-4.5A1.502 1.502 0 006.75 3v12a1.502 1.502 0 001.5 1.5h7.5a1.502 1.502 0 001.5-1.5V6a.75.75 0 00-.22-.53zM15.44 6h-2.69V3.31L15.44 6zm-7.19 9V3h3v3a1.502 1.502 0 001.5 1.5h3V15h-7.5z",
    fill: "#45464F"
  })));
}
export default SvgFileStorage;